import React from "react";
import { useLoginSession } from "./LoginSession";
import { Outlet } from "react-router-dom";
import sharedConfig from "./config";

/**
 * Redirects to the central frontend if the user doesn't have permission to access the app.
 * Note: this is not a security measure, it's just to prevent users from seeing an unusable incomplete site,
 * the real access restriction happens with the backend routes.
 */
const AppAccessChecker = ({ children, appAccessPermission }) => {
    const { userInfo, isStale } = useLoginSession(false);
    if (userInfo && !isStale && !userInfo.permissions?.includes(appAccessPermission)) {
        window.location.href = sharedConfig.centralFrontendURL;
        return null;
    }
    return (
        <>
            <Outlet />
            {children}
        </>
    );
};

export { AppAccessChecker };
